<template>
    <main-layout :showHeader="false">
        <template slot="body">
            <div class="download-body">
                <div class="slider">
                    <div class="line"></div>
                    <div class="subline inc"></div>
                    <div class="subline dec"></div>
                </div>
                <h2 class="text-gray">{{ $t('LBL_DOWNLOAD_IN_PROGRESS') }}</h2>
            </div>
        </template>
    </main-layout>
</template>

<script>

    import MainLayout from '@/layout/Main'

    export default {
        components: {
            'main-layout': MainLayout,
        },

        async mounted() {
            var self = this
            var fileId = this.$route.params.file
            var response = await Api.download(fileId)

            setTimeout(function(){
                var blob = new Blob([response], { type: 'application/zip' } )
                var link = document.createElement('a')
                var url = window.URL.createObjectURL(blob)

                link.href = url
                link.download = 'export_' + fileId + '.zip'
                document.body.appendChild(link);
                link.click()

                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)

                self.$router.push({path: '/home/ '})
            }, 2000)
        }
    }
</script>

<style lang="scss">
    .download-body {
        width: 50%;
        position: absolute;
        top: 50%; right: 50%;
        transform: translate(50%,-50%);
        text-align: center;

        h2 {
            margin-top: 1rem;
        }
    }

    .slider{
        position:relative;
        width:100%;
        height:.5rem;
        overflow-x: hidden;
    }

    .line{
        position:absolute;
        opacity: 0.4;
        background:#2196F3;
        width:150%;
        height:.5rem;
    }

    .subline{
        position:absolute;
        background:#2196F3;
        height:.5rem;
    }
    .inc{
        animation: increase 2s infinite;
    }
    .dec{
        animation: decrease 2s 0.5s infinite;
    }

    @keyframes increase {
        from { left: -5%; width: 5%; }
        to { left: 130%; width: 100%;}
    }
    @keyframes decrease {
        from { left: -80%; width: 80%; }
        to { left: 110%; width: 10%;}
    }

</style>


// WEBPACK FOOTER //
// src/pages/Download.vue